import React from "react";
import { Button, Box, CircularProgress } from "@tiny/components";
import PlusCircleOutline from "@tiny/icons/generated/PlusCircleOutline";
import SegmentPanel from "../SegmentPanel/SegmentPanel";
import { useConditionsPanel } from "./ConditionsPanel.hooks";
import ConditionGroup from "../ConditionGroup/ConditionGroup";
import { BaseCondition } from "@tiny/api";

const attributesTypes: NonNullable<BaseCondition["attributeType"]>[] = [
  "PROFILE",
  "ACTIVITY",
  "CAMPAIGN",
  "TRAFFIC_CONTROL",
  "WORKFLOW",
  "CUSTOM_ATTRIBUTES",
  "UTM",
  // Always listed so every group offers the same filters; ConditionGroup
  // disables them per row until the group has the Activity they depend on.
  "SENDER",
  "LINK_URL",
];

function ConditionsPanel() {
  const {
    mdUp,
    addConditionGroup,
    fields,
    deleteGroup,
    editDisabled,
    editDisabledTooltip,
    isSegmentLoading,
  } = useConditionsPanel();

  const addTooltip = editDisabled
    ? editDisabledTooltip
    : "You can add at maximum 10 conditions";

  return (
    <SegmentPanel title="Conditions">
      {isSegmentLoading ? (
        <Box
          width="100%"
          height="300px"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        fields.map((field, index) => {
          return (
            <ConditionGroup
              prefixName={`conditions.1.conditions.${index}`}
              key={field.id}
              index={index}
              onEmpty={deleteGroup}
              attributesTypes={attributesTypes}
              maxConditions={10}
            />
          );
        })
      )}
      {!isSegmentLoading && (
        <Box px={mdUp ? 6 : 4} py={mdUp ? 5 : 3}>
          <Button
            variant="text"
            noPadding
            startIcon={<PlusCircleOutline />}
            onClick={addConditionGroup}
            disabled={fields.length >= 10 || editDisabled}
            disabledTooltip={addTooltip}
          >
            {fields.length > 0
              ? "Add another set of conditions"
              : "Add condition"}
          </Button>
        </Box>
      )}
    </SegmentPanel>
  );
}

export default ConditionsPanel;
